module.exports = require("@nguniversal/common");